import { ref } from 'vue'
import apiClient from '../api/axios.js'

// 舵机最大速度限制的设置与下发
// 外部依赖：
//   deviceId         - 当前设备ID (Ref)
//   selectedEnv      - 当前环境对象 (Ref，需含 manager_url)
//   currentServoList - 当前设备对应的舵机列表 (Ref)
//   showSnackbar     - 显示提示信息的回调 (msg: string) => void
export function useVelocityLimit({ deviceId, selectedEnv, currentServoList, showSnackbar }) {
  const velocityLimitDialog = ref(false)
  const servoVelocityMap = ref({}) // 使用对象存储每个舵机ID对应的速度值

  // 打开速度限制设置对话框
  function openVelocityLimitDialog() {
    if (!deviceId.value) {
      showSnackbar('请先选择设备')
      return
    }

    if (!currentServoList.value || currentServoList.value.length === 0) {
      showSnackbar('当前设备没有可用的舵机列表')
      return
    }

    // 初始化速度值对象，为每个舵机设置默认值50
    const map = {}
    currentServoList.value.forEach(servo => {
      map[servo.id] = 50
    })
    servoVelocityMap.value = map
    velocityLimitDialog.value = true
  }

  // 保存速度限制
  function saveVelocityLimit() {
    if (!deviceId.value) {
      showSnackbar('请先选择设备')
      return
    }

    if (!selectedEnv.value.manager_url) {
      showSnackbar('请先选择环境')
      return
    }

    if (!currentServoList.value || currentServoList.value.length === 0) {
      showSnackbar('当前设备没有可用的舵机列表')
      return
    }

    // 构建velocity数组：最小值之前的索引补0，从最小值开始的索引使用输入值
    const servoIds = currentServoList.value.map(s => s.id)
    const maxId = Math.max(...servoIds)
    const velocityArray = new Array(maxId + 1).fill(0) // 初始化为0，长度为maxId+1以包含索引0到maxId

    // 填充每个舵机的速度值（使用舵机ID作为索引）
    currentServoList.value.forEach(servo => {
      const value = servoVelocityMap.value[servo.id]
      if (value !== undefined && value !== null) {
        velocityArray[servo.id] = value
      }
    })

    const params = {
      device_id: deviceId.value,
      params: {
        name: 'self.servo.limit_velocity',
        arguments: {
          velocity: JSON.stringify(velocityArray)
        }
      }
    }

    apiClient.post(selectedEnv.value.manager_url + '/xiaozhi/device/send-message', params, {
      headers: { 'Content-Type': 'application/json' }
    }).then(() => {
      showSnackbar('保存成功')
      velocityLimitDialog.value = false
    }).catch(err => {
      showSnackbar('保存失败：' + (err.message || '未知错误'))
    })
  }

  return {
    velocityLimitDialog,
    servoVelocityMap,
    openVelocityLimitDialog,
    saveVelocityLimit
  }
}
